export default __webpack_public_path__ + "static/media/diff_int.0481cf6c.png";